var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6252_21391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.09725 3.32476C5.45817 2.1455 7.19924 1.4975 9 1.50001C13.1423 1.50001 16.5 4.85776 16.5 9.00001C16.5 10.602 15.9975 12.087 15.1425 13.305L12.75 9.00001H15C15.0001 7.82373 14.6544 6.67336 14.006 5.69195C13.3576 4.71054 12.4349 3.94138 11.3529 3.4801C10.2708 3.01882 9.07704 2.88578 7.91997 3.09752C6.7629 3.30926 5.69359 3.85643 4.845 4.67101L4.09725 3.32476ZM13.9028 14.6753C12.5418 15.8545 10.8008 16.5025 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9.00001C1.5 7.39801 2.0025 5.91301 2.8575 4.69501L5.25 9.00001H3C2.9999 10.1763 3.34556 11.3267 3.994 12.3081C4.64244 13.2895 5.56505 14.0586 6.64712 14.5199C7.72918 14.9812 8.92296 15.1142 10.08 14.9025C11.2371 14.6908 12.3064 14.1436 13.155 13.329L13.9028 14.6753Z",
    fill: "#2E72F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6252_21391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.ef89b1e30714a0a55d815a5093bf8a75.svg";
export { ForwardRef as ReactComponent };